import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg037DrawkitNatureManColour = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "nature-man",
	viewBox: "0 0 1200 1200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-2{fill:#f3f3f3}.cls-3{fill:#d37c59}.cls-4{fill:#de8e68}.cls-5{fill:#56cad8}.cls-6{fill:#74d5de}.cls-7{fill:#fed385}.cls-8{fill:#dc8e6c}.cls-9{fill:#fb836d}.cls-14{fill:none;stroke-width:3.69px;stroke:#fed385;stroke-linecap:round;stroke-linejoin:round}" }) }),
		/* @__PURE__ */ _jsx("path", {
			d: "M711.1 528.1c0-21.86-47-74.85-84.67-74.85-28.93 0-29.4 15.3-57.59 15.3-43.46 0-75.71-72.66-159.29-72.66-89.05 0-205.41 83.58-205.41 149.14 0 93.88 506.96 116.38 506.96-16.93",
			style: { fill: "#e2e2e2" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M935.51 849.68c1-102 2.6-265.85 2.6-290.1 0-35.58-52.84-142.15-145.27-142.15-101.26 0-151.3 116.21-217.58 116.21-60.75 0-65.54-30.76-140.74-30.76-49 0-149.82 62.8-149.82 127l67.11 219.75Z",
			className: "cls-2"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 602.59,
			cy: 679.96,
			className: "cls-3",
			rx: 11.73,
			ry: 5.25,
			transform: "rotate(-87.24 602.59 679.96)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M590.19 739.68c-.2-1.94 4.32-42.23 7.92-55a16 16 0 0 1 6.71-.94l-.34 39.7-5 18.67Z",
			className: "cls-3"
		}),
		/* @__PURE__ */ _jsx("path", { d: "m620.7 683.58-31.44 2.6-1-6.22 30.26-9.57z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M544.3 999.24h13.77v11.65H544.3zm42.6 1.82h13.77v11.65H586.9z",
			className: "cls-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M542.87 805v194.88H559l18.54-104.26s2.55-56.4-34.67-90.62",
			className: "cls-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M596 801.16c.45 5.62 6.06 107.88 6.06 107.88v93.11l-16.55 1.77-10.64-99-32-99.92c4.84-2.66 40.29-7.67 53.13-3.84",
			className: "cls-6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M566.51 715.47c31.79 0 33.3 80.83 29.52 85.69s-49 8.17-53.16 3.83-15.97-89.52 23.64-89.52",
			className: "cls-7"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 607.86,
			cy: 679.96,
			className: "cls-4",
			rx: 11.73,
			ry: 5.25,
			transform: "rotate(-87.24 607.85 679.96)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M585.61 1010.89v11.65h32.74v-4.24l-17.03-7.41zm-41.74-1.84v11.65h32.74v-4.24l-17.03-7.41zm41.37-327.35 3.82-.6.6 3.81-3.82.6z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M568.84 722.5c0 2.67-12.41 3-12.41 0V696h12.41Z",
			className: "cls-3"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 568.46,
			cy: 688.32,
			className: "cls-8",
			rx: 13.03,
			ry: 19.89
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M545.77 680.12c0-6.13 2.67-10 4.84-11.23 4.19-2.4 5.94-1.33 10.16-3.2 4.57-2 8.49-7.84 13.84-7.84 5 0 4.55 2.84 7.94 3.68 2 .49 13.36-2.12 13.36 5.23 0 11.32-12.57 12.24-15.48 13.69a37 37 0 0 0-1.52-3.83c-2.29 2.36-10.58 4-11.92 4.53-3.1 1.28-4.58 6.13-4.58 9.3s-2.87 3.18-3.59 3.18c-6.63 0-13.05-4.25-13.05-13.51",
			className: "cls-9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 556.67,
			cy: 691.67,
			r: 4.33,
			className: "cls-8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 25.14,
			height: 84.61,
			x: 512.81,
			y: 718.34,
			rx: 12.57,
			ry: 12.57,
			style: { fill: "#d3d3d3" }
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 544.89,
			cy: 751.24,
			rx: 30.38,
			ry: 32.89,
			style: {
				fill: "none",
				stroke: "#d3d3d3",
				strokeMiterlimit: 10,
				strokeWidth: "3.69px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M576.84 736.83c2.53 0 15.29.53 20.48 2.4.4-2.53 2.66-38.77 6.51-50.91 1.47-1.62 7.45-1.43 7.45 0s8.51 60.88 0 67.93-37.37-2.4-38.56-3.33 4.12-16.09 4.12-16.09",
			className: "cls-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M549.66 734.69c2.82-11.48 28.36-1.93 30.67.69 2.77 3.14-2.18 20.84-6 21.66-6.23 1.35-28.33-7.46-24.67-22.35M266.38 341.65 142.64 849.68h247.49z",
			style: { fill: "#fed892" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M169.62 341.65 45.87 893.9h247.49z",
			className: "cls-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.29 891.44V395.36m0 163.59 26.89-29.23m-26.89 169.22 40.41-43.92m-40.41 189.96 62.85-68.32m-62.85-217.71-26.89-29.23m26.89 169.22-40.4-43.92m40.4 189.96-62.85-68.32",
			style: {
				fill: "none",
				stroke: "#fed385",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "3.84px"
			}
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 135.39,
			height: 197.16,
			x: 190.5,
			y: 734.34,
			className: "cls-6",
			rx: 67.69,
			ry: 67.69
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M258.19 982.94V795.85m0 79.56c37 0 37-22.28 37-56m-37 21.92c-25.65 0-25.65-15.47-25.65-38.84",
			className: "cls-14"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1152.37 849.68V667.57a81.5 81.5 0 0 0-81.28-81.28 82 82 0 0 0-13.07 1.06V377.78a55.64 55.64 0 0 0-55.63-55.64 55.64 55.64 0 0 0-55.64 55.64v44.86a81 81 0 0 0-26-4.31 81.5 81.5 0 0 0-81.28 81.29V649h-35.39a55.7 55.7 0 0 0-55.53 55.53v129.33a55 55 0 0 0 2.32 15.82Z",
			className: "cls-7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1000.16 740.85c91.61 0 91.61-41 91.61-103m-91.52 157.63c-50.4 0-50.4-22.56-50.4-56.67m50.31 110.87V364.17m0 273.68-50.22-50.23m50.22-53.41 30.39-30.38",
			style: {
				fill: "none",
				strokeWidth: "3.69px",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				stroke: "#74d5de"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M750.49 341.65a47.18 47.18 0 0 0-86.25-35.55 37.43 37.43 0 0 0-52.84 34.1v1.45Zm-458.58-73.37a47.18 47.18 0 0 1 86.25-35.55 37.4 37.4 0 0 1 52.84 34.1v1.45Z",
			className: "cls-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M924.33 936.06c-50.28 0-91 21.47-91 48h182.05c-.03-26.53-40.78-48-91.05-48",
			className: "cls-6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M502.76 1006.93c-12.55 0-22.73 8.76-22.73 19.57h45.47c0-10.81-10.18-19.57-22.74-19.57M833.3 902.44c-12.56 0-22.73 13-22.73 29.06H856c0-16.05-10.15-29.06-22.7-29.06m-712.43 72.13c-20 0-36.16 6.51-36.16 14.53H157c0-8.02-16.16-14.53-36.13-14.53m909.68 0c-20 0-36.16 6.51-36.16 14.53h72.31c0-8.02-16.18-14.53-36.15-14.53",
			className: "cls-9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 87.67,
			height: 127.66,
			x: 838.22,
			y: 746.55,
			className: "cls-6",
			rx: 43.83,
			ry: 43.83
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M882.06 907.53V786.38m0 51.52c23.94 0 23.94-14.43 23.94-36.26m-23.94 14.19c-16.61 0-16.61-10-16.61-25.16",
			style: {
				fill: "none",
				stroke: "#fed385",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.39px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M331.71 947.65h81.04M668.4 893.9h53.74m-94.27 13.63h53.75m-564.74 11.11h53.75m577.92 80.6h75.55",
			className: "cls-14"
		})
	]
});
export default Svg037DrawkitNatureManColour;
